// Disable webpack overlay
// @ts-ignore
if (module.hot) {
  // @ts-ignore
  module.hot.accept(() => {
    // Prevent overlay on hot reload
  })
}

// @ts-ignore
if (window.__webpack_dev_server_client__) {
  // @ts-ignore
  window.__webpack_dev_server_client__.overlayType = 'none'
}
